// components/GoldRateMarquee.js
import React, { useEffect, useState } from "react";
import { liveGoldRate } from "../../api/Api";

const GoldRateMarquee = () => {
  const [goldRates, setGoldRates] = useState([]);

  useEffect(() => {
    const fetchGoldRates = async () => {
      try {
        const response = await liveGoldRate();
        const data = response;

        if (data && Array.isArray(data.history) && data.history.length > 1) {
          const today = data.history[0];
          const yesterday = data.history[1];

          // Function to extract numeric price from "₹12,328 (0)"
          const extractPrice = (str = "") => parseInt(str.split(" ")[0].replace(/₹|,/g, ""), 10);

          // Function to calculate % change and direction
          const calcChange = (todayStr, yesterdayStr) => {
            const todayRate = extractPrice(todayStr);
            const yesterdayRate = extractPrice(yesterdayStr);

            const diff = todayRate - yesterdayRate;
            const percent = ((diff / yesterdayRate) * 100).toFixed(2);
            const direction = diff > 0 ? "UP" : diff < 0 ? "DOWN" : "SAME";
            const change = `${diff > 0 ? "+" : diff < 0 ? "" : ""}${percent}%`;
            return { change, direction };
          };

          // Calculate changes for 24K and 22K
          const change24K = calcChange(today["24K"], yesterday["24K"]);
          const change22K = calcChange(today["22K"], yesterday["22K"]);

          const formattedRates = [
            {
              type: "24K Gold",
              rate: today["24K"],
              change: change24K.change,
              direction: change24K.direction,
            },
            {
              type: "22K Gold",
              rate: today["22K"],
              change: change22K.change,
              direction: change22K.direction,
            },
            { type: "City", rate: data.city },
            { type: "Date", rate: data.date },
          ];

          setGoldRates(formattedRates);
        }
      } catch (err) {
        console.error("Error fetching live gold rates:", err);
      }
    };

    fetchGoldRates();
  }, []);

  return (
    <div className="w-full bg-gradient-to-r from-amber-500 to-yellow-400 py-3 shadow-lg border-b border-amber-600 mt-32">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4 mr-8">
            <span className="text-white font-bold text-sm bg-amber-600 px-3 py-1 rounded-full shadow-sm">
              💰 LIVE RATES
            </span>
          </div>

          <div className="flex-1 overflow-hidden">
            <div className="animate-marquee whitespace-nowrap">
              {goldRates.length > 0 ? (
                goldRates.map((item, index) => (
                  <span
                    key={index}
                    className="inline-block mx-6 text-white font-medium"
                  >
                    <span className="text-amber-900 font-bold">{item.type}:</span>
                    <span className="mx-2">{item.rate}</span>
                    {item.change && (
                      <span
                        className={`text-xs px-2 py-1 rounded-full ${
                          item.direction === "UP"
                            ? "bg-green-500 text-white"
                            : item.direction === "DOWN"
                            ? "bg-red-500 text-white"
                            : "bg-gray-500 text-white"
                        }`}
                      >
                        {item.direction === "UP"
                          ? "▲"
                          : item.direction === "DOWN"
                          ? "▼"
                          : "•"}{" "}
                        {item.change}
                      </span>
                    )}
                  </span>
                ))
              ) : (
                <span className="text-white">Loading live gold rates...</span>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-2 ml-8">
            <span className="text-amber-900 text-xs font-semibold bg-amber-200 px-2 py-1 rounded">
              📈 Updated Today
            </span>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default GoldRateMarquee;
